import page from '../_rubric/_.vue';
export default page;
